import {
  Banner,
  Page,
  SimplePagination,
  Table,
  Text,
} from '@dixa/lib-shared-habla';

import { ChangeSmsFunctionalityModal } from './components/changeSmsFunctionalityModal/changeSmsFunctionalityModal';
import { EditSmsQueueModal } from './components/editSmsQueueModal/editSmsQueueModal';
import { SmsTableRow } from './components/smsTableRow/smsTableRow';
import { SmsTableSkeletonRow } from './components/smsTableSkeletonRow/smsTableSkeletonRow';
import { SmsTableProps } from './smsTable.types';

/**
 * Represents a component that displays a table with the sms capable phone
 * numbers.
 */
export const SmsTable = ({
  smsTableData,
  isLoading,
  hasNextPage,
  hasPreviousPage,
  nextPage,
  previousPage,
  onSmsTableDataItemChanged,
}: SmsTableProps): JSX.Element => {
  return (
    <>
      <Page.Section
        title="All phone numbers with text message support"
        callout={
          <Banner
            variant="info"
            description={
              <Text.Paragraph as="span" variant="4">
                Give your customers text message support. Interested? Contact
                our Customer Success team for more details.
              </Text.Paragraph>
            }
          />
        }
      >
        <Table loading={isLoading} loadingStrategy="disabled" stickyHeader>
          <Table.Thead>
            <Table.Tr>
              <Table.Th width="30%">Number</Table.Th>
              <Table.Th width="30%">Name</Table.Th>
              <Table.Th width="25%">Queue</Table.Th>
              <Table.Th width="15%">Enabled</Table.Th>
            </Table.Tr>
          </Table.Thead>

          <Table.Tbody>
            {smsTableData.map((smsTableDataItem) =>
              isLoading ? (
                <SmsTableSkeletonRow
                  key={smsTableDataItem.phoneNumber.e164_format}
                />
              ) : (
                <SmsTableRow
                  key={smsTableDataItem.phoneNumber.e164_format}
                  smsTableDataItem={smsTableDataItem}
                  onSmsTableDataItemChanged={onSmsTableDataItemChanged}
                />
              ),
            )}
          </Table.Tbody>

          <Table.Footer>
            <SimplePagination
              nextButtonClick={nextPage}
              nextButtonDisabled={!hasNextPage}
              previousButtonClick={previousPage}
              previousButtonDisabled={!hasPreviousPage}
            />
          </Table.Footer>
        </Table>
      </Page.Section>

      <EditSmsQueueModal />

      <ChangeSmsFunctionalityModal />
    </>
  );
};
